export namespace Route {
  export function parseId(id: string | null): number | 'new' {
    if (id === null) {
      throw new Error('No id present in routing params.');
    }

    if (id === 'new') {
      return id;
    }

    return Number(id);
  }
}
